exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".planner-space[data-v-6f820168]{width:100%;display:grid;grid-template-columns:repeat(2, 1fr)}.planner-column[data-v-6f820168]{margin:0;min-height:50px}.drop-target[data-v-6f820168]{border:thin dashed #adadad;border-radius:5px;box-sizing:border-box;color:#adadad;width:98%;margin:3px auto;padding:10px;text-align:center}.craft-item[data-v-6f820168]{border:thin solid;background-color:#fff;border-radius:5px;box-sizing:border-box;width:98%;margin:3px auto;padding:10px;text-align:center;z-index:20}", ""]);

// exports
